import { render } from "./HotelsBookOfflineHistory.vue?vue&type=template&id=0d677438"
import script from "./HotelsBookOfflineHistory.vue?vue&type=script&lang=js"
export * from "./HotelsBookOfflineHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__